import React, { ReactElement } from "react";
import VatTaxDeliveryReport from "../../components/Finance/VatTaxDeliveryReport";
import Layout from "../../components/layout";

const VatTaxDeliveryReportPage = (): ReactElement => {
  return (
    <Layout>
      <VatTaxDeliveryReport />
    </Layout>
  );
};

export default VatTaxDeliveryReportPage;
